import React from 'react';
import selectIcon from '@design-system/Assets/selectionIcon.svg';
import coffeeIcon from '@design-system/Assets/coffeeIcon.svg';
import clockIcon from '@design-system/Assets/clockIcon.svg';
import recipeIcon from '@design-system/Assets/reciepIcon.svg';

export default function Offering() {
  return (
    <React.Fragment>
      <h2 className="text-3xl lg:text-4xl text-center font-bold my-16 md:mt-20 md:mb-32">
        What we offer
      </h2>
      <section className="flex flex-col md:flex-row md:gap-4 lg:gap-20 px-6 md:px-6 lg:px-16">
        <div className="">
          <div className="flex  md:flex-col mt-10 md:mt-0">
            <div className="items-center md:items-left">
              <img src={selectIcon} />
            </div>
            <h3 className="offering-heading mt-3">Wide selection of ingredients</h3>
          </div>
          <p className="offering-text md:mt-0">
            Enjoy a wider selection of ingredients, spices, specialty items with
            competitive prices from different sellers.
          </p>
        </div>
        <div>
          <div className="flex  md:flex-col mt-10 md:mt-0">
            <div className="items-center md:items-left">
              <img src={coffeeIcon} />
            </div>
            <h3 className="offering-heading mt-3">
              Easy ordering
              <br className="hidden md:block" /> process
            </h3>
          </div>
          <p className="offering-text md:mt-0">
            Enjoy the convenience of seamless purchase of all the ingredients you
            need for your recipes
          </p>
        </div>
        <div>
          <div className="flex  md:flex-col mt-10 md:mt-0">
            <div className="items-center md:items-left">
              <img src={clockIcon} />
            </div>
            <div>
              <h3 className="offering-heading md:mt-3">
                Same-Day <br />
                Doorstep Delivery
              </h3>
            </div>
          </div>
          <p className="offering-text md:mt-0">
            Experience the convenience of your ingredients delivered right to your
            doorstep within hours
          </p>
        </div>
        <div>
          <div className="flex  md:flex-col mt-10 md:mt-0 ">
            <div className="items-center md:items-left">
              <img src={recipeIcon} />
            </div>
            <h3 className="lg:text-2xl font-bold mb-2 mt-3">
              Recipe <br />
              <br />
            </h3>
          </div>
          <p className="offering-text">
            Offer step-by-step instructions to guide users through the cooking
            process
          </p>
        </div>
      </section>
    </React.Fragment>
  );
}
